<template lang="pug">
  .coach-detail-gallery
    h4 GALLERY
    .gallery(v-if="coach.gallery1 && coach.gallery1.url")
      .video-container
        iframe(
          :src="gallery1Src"
          frameborder="0"
          allowfullscreen)
      multiline-text-view(
        v-if="coach.gallery1.description"
        :text="coach.gallery1.description"
        class="multiline-text-view"
      )
    .gallery(v-if="coach.gallery2 && coach.gallery2.url")
      .video-container
        iframe(
          :src="gallery2Src"
          frameborder="0"
          allowfullscreen)
      multiline-text-view(
        v-if="coach.gallery2.description"
        :text="coach.gallery2.description"
        class="multiline-text-view"
      )
    .gallery(v-if="coach.gallery3 && coach.gallery3.url")
      .video-container
        iframe(
          :src="gallery3Src"
          frameborder="0"
          allowfullscreen)
      multiline-text-view(
        v-if="coach.gallery3.description"
        :text="coach.gallery3.description"
        class="multiline-text-view"
      )
</template>

<style lang="scss" scoped>
.coach-detail-gallery {
  padding: 0 16px;

  h4 {
    padding: 0;
    margin: 0 0 24px;
    text-align: center;
    @extend %title;
    opacity: 0.8;
    font-size: 16px;
    letter-spacing: 4px;
    line-height: 28px;
  }

  .gallery {
    margin-bottom: 82px;

    .video-container {
      position: relative;
      padding-bottom: 56.25%;
      padding-top: 30px;
      height: 0;
      overflow: hidden;
    }

    .video-container iframe,
    .video-container object,
    .video-container embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .multiline-text-view {
      margin: 16px 0;
      padding: 0;
    }
  }
}
</style>

<script>
import MultilineTextView from '@/components/molecules/MultilineTextView'

export default {
  components: {
    MultilineTextView,
  },
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
  computed: {
    gallery1Src() {
      return this.gallerySrc(this.coach.gallery1.url)
    },
    gallery2Src() {
      return this.gallerySrc(this.coach.gallery2.url)
    },
    gallery3Src() {
      return this.gallerySrc(this.coach.gallery3.url)
    },
  },
  methods: {
    gallerySrc(url) {
      return `https://www.youtube.com/embed/${this.videoId(url)}`
    },
    videoId(url) {
      return url.replace(/http.+(embed\/|watch\?v=)/, '')
    },
  },
}
</script>
